
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import UNData from "./UNData";

export default {
  name: "app-unidade-update",
  data() {
    return {
      unidade: new UNData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getUnidade(id) {
      const { data } = await this.$http.post("/produtos/get-unidades-medida", {
        id: id,
      });

      return data;
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        this.setLoading(true);

        const unidade = await this.getUnidade(id);

        this.setLoading(false);

        if (!unidade.id || unidade == null) {
          this.$router.push({ name: "unidades" });
          return this.$toast.error("Unidade não encontrada!");
        }

        this.unidade = new UNData(unidade);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
